import { InstructionType, FieldType, ProcedureStatus, LAB_DRAW_TASK_TYPE_ID, LAB_DRAW_TASK_ID } from '@caresend/types';
import { generateID } from './id.js';
import { initialPhone } from './user.js';

const initProcedureInstruction = (type, fields) => Object.assign({
  type,
  instruction: ''
}, fields ? {
  fields
} : undefined);
const initProcedureContact = () => ({
  custom: false
});
const initCCAccount = id => ({
  id: id !== null && id !== void 0 ? id : generateID(),
  firstName: '',
  lastName: '',
  phone: initialPhone(),
  fax: initialPhone(),
  npi: ''
});
/**
 * Default value for initializing procedures.
 * TaskType after Task due to initDraftProcedure
 */

const initProcedure = (bookingID, orderID, taskTypeID = LAB_DRAW_TASK_TYPE_ID, taskID = LAB_DRAW_TASK_ID) => ({
  bookingID,
  contact: initProcedureContact(),
  creationTimestamp: Date.now(),
  id: generateID(),
  instructions: [initProcedureInstruction(InstructionType.DIAGNOSIS), initProcedureInstruction(InstructionType.NURSE), initProcedureInstruction(InstructionType.FASTING, [{
    label: 'Fasting instructions',
    type: FieldType.FREE_TEXT
  }])],
  orderID,
  status: ProcedureStatus.DRAFT,
  taskID,
  taskTypeID
});

export { initCCAccount, initProcedure, initProcedureContact, initProcedureInstruction };
